import { logCustomAttributes } from '../../utils/logging.js';
import { debugLog } from '../../utils/debugLog.js';

const onCallMonarchWithPreampCallback = setMonarchResponse => (err, res) => {
  debugLog('callMonarchWithPreamp - finished with response:', res);
  if (err) {
    debugLog('callMonarchWithPreamp - returned error:', err);
    setMonarchResponse(true);
  } else {
    const monarchExperience = getMonarchExperienceReturnValue(res ?? {});
    if (monarchExperience) {
      const {
        name,
        experienceNumber
      } = monarchExperience;
      debugLog(`callMonarchWithPreamp - returned an experience: ${experienceNumber}, '${name}'`);
      logCustomAttributes([{
        name: `monarch.experienceName`,
        value: name
      }, {
        name: `monarch.experienceNumber`,
        value: experienceNumber
      }]);
    }
    debugLog(`callMonarchWithPreamp - setting state`);
    setMonarchResponse(res);
  }
};
const formatMonarchAssets = monarchAssetPlacements => {
  monarchAssetPlacements.forEach(obj => {
    const {
      asset
    } = obj;
    const {
      metadata
    } = asset;
    if (typeof metadata === 'string') {
      asset.metadata = JSON.parse(metadata);
    }
  });
  const cleanedMonarchAssets = {};
  monarchAssetPlacements.forEach(assetPlacement => {
    const {
      asset,
      placement
    } = assetPlacement;
    cleanedMonarchAssets[placement.placementId] = asset;
  });
  return cleanedMonarchAssets;
};

/**
 * Iterates through the raw response and if one of the rules evaluated
 * in the ruleset returned a Preamp Experience, it returns that
 * If there isn't a Preamp Experience returned by any of the returns, it returns undefined
 *
 * @param monarchResponse the raw response object from Monarch
 * @returns MonarchExperienceReturnValue | undefined
 */
const getMonarchExperienceReturnValue = monarchResponse => {
  let experienceReturnValue = undefined;
  if (monarchResponse && typeof monarchResponse === 'object') {
    Object.values(monarchResponse).forEach(value => {
      // checking if return value is a Preamp Experience
      if (value && typeof value === 'object' && 'experienceId' in value && 'experienceNumber' in value) {
        experienceReturnValue = value;
      }
    });
  }
  return experienceReturnValue;
};

// Unlike the regular return from a Monarch ruleset, the auto call can evaluate multiple rulesets so there's an extra level
const getAutoMonarchExperienceReturnValue = monarchResponse => {
  let experienceReturnValue = undefined;
  if (monarchResponse && typeof monarchResponse === 'object') {
    // iterating over all the rulesets
    Object.values(monarchResponse).forEach(ruleset => {
      if (ruleset && typeof ruleset === 'object') {
        Object.values(ruleset).forEach(rule => {
          if (rule && typeof rule === 'object' && 'returnType' in rule && rule.returnType === 'preampExperience' && 'value' in rule && typeof rule.value === 'object') {
            experienceReturnValue = rule.value;
          }
        });
      }
    });
  }
  return experienceReturnValue;
};

export { formatMonarchAssets, getAutoMonarchExperienceReturnValue, getMonarchExperienceReturnValue, onCallMonarchWithPreampCallback };
